import BigNumber from "bignumber.js";

export const BN = BigNumber;
BigNumber.config({ DECIMAL_PLACES: 9 });
export const numberFormat = new Intl.NumberFormat("en-GB");
export const divisor = new BN(10).pow(new BN(18));

export const contracts = {
  // WAGMI
  WAGMI_CONTRACT_ADDRESS: "0xcddb9f34d6a48e5d051561e6d9fbfc96050cd429",
  wagmiAbiJson: require("./abi/wagmi.json"),
  // Why WAGMI
  WHY_WAGMI_CONTRACT_ADDRESS: "0xE1C1F67B6FA75cBaf3a170A0470Fa40EfDbe05e6",
  whyWagmiAbiJson: require("./abi/why_wagmi.json"),
  // NGMI NFT
  NGMI_NFT_CONTRACT_ADDRESS: "0x854Bd71322Cd05e30E88e04549F91a728F49dEC7",
  ngmiAbiJson: require("./abi/ngmi_nft.json"),
  // WAGMI_V2
  wagmiV2AbiJson: require("./abi/wagmi_v2.json"),
  // xWAGMI
  xWagmiAbiJson: require("./abi/xwagmi.json"),
  // MasterChef
  masterChefAbiJson: require("./abi/masterchef.json"),
  // PancakeV2LP
  pancakeV2LpAbiJson: require("./abi/pancakeV2LP.json"),
  WAGMI_V1_BNB_PANCAKE_V2_LP_ADDRESS:
    "0x2da0cfb1396447bc12eFE609901E23E9c3f1B97b",
};
